import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Form, Image, InputGroup, Alert, Button } from 'react-bootstrap';
import UserAPI from '../components/UserAPI';
import TuneCoinImage from '../images/tunecoin.png';
import { padding, marginNumber, navigationWidthNumber, buttonPaddingNumber, secondaryColor, secMenuWidthNumber, backgroundColor, secondaryBackgroundColor } from '../utils/DisplaySettings';
import userProfileImage from '../images/userprofile.png';
import CustomButton from '../utils/StyledComponents';
import EnvironmentVariables from '../utils/EnvironmentVariables';

const Profile = () => {
    const [YT_channel_URL, setYT_channel_URL] = useState(null);
    const [TW_channel_URL, setTW_channel_URL] = useState(null);
    const [statusMessage, setStatusMessage] = useState('');
    const [credits, setCredits] = useState(null);
    const idToken = localStorage.getItem('idToken');
    

    const getCredits = async () => {
        const storedToken = localStorage.getItem('idToken');
        if (!storedToken) return;

        try {
            const bodyData = JSON.stringify({
                'request_type': 'user',
                'idToken': storedToken,
                'user_request_type': 'getcredits'
            });
            const jsonData = await UserAPI(bodyData);
            if (jsonData) {  // Check if component is still mounted
                const result = JSON.parse(jsonData.body);
                if (result && result.credits !== undefined) {  // Validate credits exist
                    setCredits(result.credits);
                }
            }
        } catch (error) {
            console.error('Error fetching credits:', error);
        }
    };

    const getSettings = async () => {
        const idToken = localStorage.getItem('idToken');
        try {
            if (!idToken) {
                console.error('No token available');
                return;
            }

            console.log('Getting settings');
            const jsonData = await UserAPI(JSON.stringify({ 
                'request_type': 'user', 
                'idToken': idToken,
                'user_request_type': 'getsettings' 
            }));
            
            if (!jsonData) return;
            
            const result = JSON.parse(jsonData.body);
            console.log(result);
            setYT_channel_URL(result.YT_channel_URL);
        } catch (error) {
            console.error('Error fetching settings:', error);
        }
    };

    

    useEffect(() => {
        console.log('Profile component mounted');
        getSettings();
        getCredits();
        return () => {
            console.log('Profile component unmounted');
        };
    }, []);

    const setChannel = async (type) => {
        const inputID = type === 'YT' ? 'embedYTURLinput' : 'embedTWURLinput';
        const setting = type === 'YT' ? 'YT_channel_URL' : 'TW_channel_name';

        const idToken = localStorage.getItem('idToken');
        if (!idToken) {
            console.error('No token available');
            return;
        }

        const channel = document.getElementById(inputID)?.value || '';
        
        if (type === 'YT') {
            // Add URL validation
            const youtubeChannelRegex = /^https:\/\/www\.youtube\.com\/@[\w-]+$/;
            if (!youtubeChannelRegex.test(channel)) {
                alert('Please enter a valid YouTube channel URL in the format: https://www.youtube.com/@CHANNELNAME');
                return;
            }
        }
        const requestBody = JSON.stringify({
            'request_type': 'user',
            'idToken': idToken,
            'user_request_type': 'changesetting',
            'setting': setting,
            'value': channel
        });
        
        try {
            const response = await UserAPI(requestBody);
            if (type === 'YT') {
                setYT_channel_URL(channel);
            }
            else if (type === 'TW') {
                setTW_channel_URL(channel);
            }
            if (response) {
                setStatusMessage('Channel URL updated successfully!');
            }
        } catch (error) {
            console.error('Error updating channel URL:', error);
            setStatusMessage('Error updating channel URL');
        }
    };

    useEffect(() => {
        if (statusMessage) {
            const timer = setTimeout(() => {
                setStatusMessage('');
            }, 3000);
            return () => clearTimeout(timer);
        }
    }, [statusMessage]);

    return (
        <Container fluid className="mt-5">
            {idToken ? (
                <>
                    <Row className="justify-content-center mb-4">
                        <Col className="text-center">
                            <Image
                                src={userProfileImage}
                                alt="Profile Console"
                                fluid
                                style={{ maxWidth: '100%' }}
                            />
                        </Col>
                    </Row>

                    <Row>
                        <Col>
                            {/* Credits Card */}
                            <Card 
                                className="mb-4"
                                bg="dark"
                                text="white"
                                style={{
                                    border: `0.125rem solid ${secondaryColor}`,
                                    borderRadius: '0.9375rem',
                                    boxShadow: `0 0 0.9375rem ${secondaryColor}`
                                }}
                            >
                                <Card.Body>
                                    <Row className="align-items-center justify-content-center">
                                        <Col xs="auto">
                                            <p className="mb-0">Credits: {credits}<Image src={TuneCoinImage} alt="TuneCoin" style={{ width: '1rem', height: '1rem', margin: '0 0.2rem' }} /></p>
                                        </Col>
                                        <Col xs="auto" className="d-flex align-items-center">
                                            <p className="mb-0 d-flex align-items-center">
                                                (1
                                                <Image src={TuneCoinImage} alt="TuneCoin" style={{ width: '1rem', height: '1rem', margin: '0 0.2rem' }} />
                                                =0.01 EUR)
                                            </p>
                                        </Col>
                                        <Col xs="auto">
                                            <InputGroup style={{ gap: '0.5rem' }} className="align-items-center">
                                                <Form.Control
                                                    type="number"
                                                    min="1"
                                                    placeholder="Amount"
                                                    id="creditsInput"
                                                    style={{ 
                                                        width: '6rem',
                                                        height: 'calc(1.5em + 1rem + 2px)'  // Standard Bootstrap form control height
                                                    }}
                                                />
                                                <Button 
                                                    variant="outline-light"
                                                    onClick={() => {
                                                        console.log('Add credits clicked');
                                                        alert('Thank you for your interest! This feature will be available soon.');
                                                    }}
                                                    style={{
                                                        height: 'calc(1.5em + 1rem + 2px)',  // Standard Bootstrap form control height
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center'
                                                    }}
                                                >
                                                    Add
                                                </Button>
                                            </InputGroup>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>

                            {/* YouTube Channel Card */}
                            <Card 
                                className="mb-4"
                                bg="dark"
                                text="white"
                                style={{
                                    border: `0.125rem solid ${secondaryColor}`,
                                    borderRadius: '0.9375rem',
                                    boxShadow: `0 0 0.9375rem ${secondaryColor}`
                                }}
                            >
                                <Card.Body>
                                    <Row className="justify-content-center">
                                        <Col xs={12}>
                                            <div className="d-flex align-items-center justify-content-center gap-3 flex-wrap">
                                                <Form.Control
                                                    id="embedYTURLinput"
                                                    type="text"
                                                    style={{ width: '100%', maxWidth: '50rem' }}
                                                    placeholder={`Enter ${YT_channel_URL ? `(current: ${YT_channel_URL})` : 'Youtube channel URL - format https://www.youtube.com/@CHANNELNAME'}`}
                                                />
                                                <Button 
                                                    variant="outline-light"
                                                    onClick={() => setChannel('YT')}
                                                >
                                                    Set Youtube Channel URL
                                                </Button>
                                                {statusMessage && (
                                                    <Alert 
                                                        variant="info" 
                                                        className="mb-0 py-2"
                                                        style={{ transition: 'opacity 0.3s ease-in-out' }}
                                                    >
                                                        {statusMessage}
                                                    </Alert>
                                                )}
                                            </div>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                            {/*Twitch Channel Card*/}
                            <Card 
                                className="mb-4"
                                bg="dark"
                                text="white"
                                style={{
                                    border: `0.125rem solid ${secondaryColor}`,
                                    borderRadius: '0.9375rem',
                                    boxShadow: `0 0 0.9375rem ${secondaryColor}`
                                }}
                            >
                                <Card.Body>
                                    <Row className="justify-content-center">
                                        <Col xs={12}>
                                            <div className="d-flex align-items-center justify-content-center gap-3 flex-wrap">
                                                <Form.Control
                                                    id="embedTWURLinput"
                                                    type="text"
                                                    style={{ width: '100%', maxWidth: '50rem' }}
                                                    placeholder={`Enter ${TW_channel_URL ? `(current: ${TW_channel_URL})` : 'Twitch channel name'}`}
                                                />
                                                <Button 
                                                    variant="outline-light"
                                                    onClick={() => setChannel('TW')}
                                                >
                                                    Set Twitch Channel Name
                                                </Button>
                                                {statusMessage && (
                                                    <Alert 
                                                        variant="info" 
                                                        className="mb-0 py-2"
                                                        style={{ transition: 'opacity 0.3s ease-in-out' }}
                                                    >
                                                        {statusMessage}
                                                    </Alert>
                                                )}
                                            </div>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </>
            ) : (
                <Row className="justify-content-center mt-3">
                    <Col xs={12} sm={8} md={6} lg={4} className="text-center">
                        <p>Please login to view your profile.</p>
                        <Button 
                            variant="outline-light"
                            onClick={() => window.location.href = EnvironmentVariables.AuthURL}
                        >
                            Sign up/login
                        </Button>
                    </Col>
                </Row>
            )}
        </Container>
    );
};

export default Profile;